import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    form: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
      width: "100%",
    },
    sectionSubheader: {
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.gray500,
    },
    tabsContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(12),
    },
    addIcon: {
      color: theme.primary500,
      fontSize: 32,
    },
    templateBox: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      borderRadius: 8,
      border: `1px solid ${theme.gray200}`,
      padding: theme.spacing(8, 8, 6),
      height: 196,
      transition: "0.3s",
      "&:hover": {
        backgroundColor: `${theme.primary50}33`,
        borderColor: theme.gray800,
        cursor: "pointer",
      },
    },
    highlightedBox: {
      backgroundColor: `${theme.primary50}33`,
      borderColor: theme.primary500,
      "& p": {
        color: theme.gray800,
      },
    },
    templateTitle: {
      fontSize: 14,
      fontWeight: 500,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(4),
      "@media (max-width: 1200px)": {
        fontSize: 13,
      },
    },
    templateDescription: {
      fontSize: 14,
      color: theme.gray500,
      "@media (max-width: 1200px)": {
        fontSize: 13,
      },
    },
    button: {
      padding: 0,
      marginTop: "auto",
      alignSelf: "self-start",
      fontSize: 13,
      lineHeight: "13px",
      "& span": {
        width: "16px",
      },
    },
    boxIcon: {
      display: "flex",
      "& svg": {
        marginLeft: theme.spacing(-1.5),
      },
    },
    paginationItem: {
      width: 40,
      height: 40,
      "&:hover": {
        borderRadius: "10px",
      },
    },
    activePaginationItem: {
      borderRadius: "10px !important",
      backgroundColor: `${theme.gray50} !important`,
      border: `0.1em solid ${theme.gray200}`,
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(8),
    },
    searchInput: {
      borderRadius: "4px",
      border: `1px solid ${theme.gray200}`,
      height: 36,
      width: 200,
    },
    emptyStateContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: theme.spacing(23, 0),
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(5),
      borderRadius: "140px",
      backgroundColor: theme.primary50,
      marginBottom: theme.spacing(8),
    },
    icon: {
      height: "24px",
      width: "24px",
    },
    emptyStateTitle: {
      fontSize: 24,
      fontWeight: 500,
      lineHeight: "29px",
      color: theme.primary800,
      marginBottom: theme.spacing(4),
    },
    emptyStateSubtitle: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "24px",
      color: theme.gray500,
      marginBottom: theme.spacing(12),
      textAlign: "center",
    },
    link: {
      fontSize: 14,
    },
  }),
);
